module.exports = __webpack_public_path__ + "img/pic1.f60f6e08.png";